import React from 'react';
import { KEY_CONTENT_ROUTES } from 'routing';
import cn from 'classnames';
import desktop from 'static/img/home/onlineLessonsBlock/desktop.svg';

import css from './OnlineLessonsBlock.module.scss';

function OnlineLessonsBlock () {
  return (
    <section className={cn(css.wrapper, 'container')}>
      <h3 className={cn(css.title, css.mobile)}>Award winning online lessons</h3>

      <div className={css.leftSide}>
        <img src={desktop} alt='' />
      </div>
      <div className={css.rightSide}>
        <h3 className={cn(css.title, css.desktop)}>Award winning online lessons</h3>
        <p className={css.description}>
          <span>Our virtual experience makes online learning easy and fun. All tutors are trained and qualified to deliver high-quality lessons to you anywhere in the UK. </span>
          <span>Your online lessons are tailored to your specific requirements, ensuring you meet your expectations and achieve your goals.</span>
        </p>
        <a className={cn(css.startedBtn, 'btn-primary')} rel="noopener noreferrer" href={KEY_CONTENT_ROUTES.SEARCH_RESULTS}>Get started</a>
      </div>
    </section>
  );
}
export default OnlineLessonsBlock;
